var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-empty',{attrs:{"image-style":{
    height: '60px',
  }}},[_c('span',{staticStyle:{"color":"lightgrey"},attrs:{"slot":"description"},slot:"description"},[_vm._v("暂无数据")]),_c('a-button',{attrs:{"type":"primary"},on:{"click":_vm.newRecord}},[_vm._v(" 记一笔 ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }